import type { ReactNode } from 'react'

export function EmptyState({ icon, title, description, action }: { icon?: ReactNode; title: ReactNode; description?: ReactNode; action?: ReactNode }) {
  return (
    <div className="flex flex-col items-center gap-2 rounded-xl border border-line bg-surface px-6 py-10 text-center">
      {icon && <div className="text-muted" aria-hidden="true">{icon}</div>}
      <h3 className="m-0 font-heading text-base font-semibold text-ink">{title}</h3>
      {description && <p className="m-0 max-w-md text-sm text-ink-secondary">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  )
}
